<template>
    <div class="hotel-block" :class="{'hotel-loading': hotel.loading}">
        <hotel-block-header 
        :hotel="hotel"
        :force-favorite="isFavoriteItem"
        @titleclick="readMore"
        @addFavorite="onAddFavorite"
        @showrating="onShowRating"
        ></hotel-block-header>
        <div class="hotel-block__image" @click="readMore">
            <transition name="image-transition">
                <span :style="{'background-image': hotelImg}"></span>
            </transition>
        </div>
        <p class="hotel-block__description">
            <transition name="description-transition">
                <span v-text="description"></span>
            </transition>
        </p>
        <div class="hotel-travel-dates" v-if="dateFrom || dateTo">
            <span class="hotel-travel-dates__from" v-text="dateFrom"></span>
            <img src="./../../../img/icons/icon-travel-date-arrow.svg" alt="" class="hotel-travel-dates__arrow">
            <span class="hotel-travel-dates__from" v-text="dateTo"></span>
        </div>
        <total-price v-if="hotel.totalPrice" :total-price="hotel.totalPrice" :currency="hotel.currency"></total-price>
        <button @click="readMore" class="btn btn--positive" v-if="hotel.id">
            <span class="btn__icon btn__icon--left">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.08 28.08"><path d="M21.22,2.62l-3,3L3.54,3.33,0,6.86l13,4L7.78,16.06H2.12L0,18.18,7.78,20.3,9.9,28.08,12,26V20.3l5.24-5.23,4,13,3.53-3.53L22.49,9.83l3-3C27.8,4.53,28.75,1.67,27.58.5S23.55.29,21.22,2.62Z"/></svg>
            </span>
            <span class="btn__text" v-text="translations.more_info"></span>
            <span class="btn__icon btn__icon--right">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.01 26.01"><path d="M26.13,10.88l-10-10a3,3,0,1,0-4.25,4.24L16.76,10H3a3,3,0,0,0,0,6H16.76l-4.88,4.88a3,3,0,0,0,4.25,4.25l10-10A3,3,0,0,0,27,13,3,3,0,0,0,26.13,10.88Z"/></svg>
            </span>
        </button>
    </div>
</template>

<script type="text/javascript">
    import HotelBlockHeader from './hotel-block-header.vue';
    import TotalPrice from '../total-price.vue';
    import Moment from 'moment';
    import Modal from '../modal.vue';
    import MsgBlock from '../msg-block.vue';
    import _ from 'underscore';
    import { trackEvent } from '../../tracker';

    export default {
        props: {
            hotel: {type: Object, default() {return { }}},
            isFavoriteItem: {type: Boolean, default: false}
        },
        data() {
            return {
                translations: APP_CONFIG.TRANSLATION.HOTEL_BLOCK,
                favoriteLoading: false,
            }
        },
        computed: {
            dateFrom() {
                return (this.hotel && this.hotel.dateFrom) ? this.hotel.dateFrom.format('DD. MMM. YYYY') : '';
            },
            dateTo() {
                return (this.hotel && this.hotel.dateTo) ? this.hotel.dateTo.format('DD. MMM. YYYY') : '';
            },
            hotelImg() {
                if(!this.hotel.img) {
                    let img = APP_CONFIG.THEME_PATH + '/assets/img/hotel-no-image.svg';
                    return 'url(' + img + ')';
                }
                return 'url(' + this.hotel.img + ')';
            },
            description() {
                return this.hotel.description || this.translations.no_description
            },
            query() {
                return this.$store.getters.travelQuery;
            }
        },
        methods: {
            onAddFavorite() {
                trackEvent({
                    event:  'Gem tilbud til Mit Skov Rejser',
                    action: this.hotel,
                    destination: (this.$store) ? this.$store.state.destination : null,
                    'interaction-type': 'noninteraction'
                })
            },
            onShowRating() {
                trackEvent({
                    event:  'Hover - Smileyordning',
                    action: this.hotel,
                    destination: (this.hotel && this.hotel.rating.recommendation >= 35) ? true : false,
                    'interaction-type': 'noninteraction'
                })
            },
            createUser() {
                this.$router.push({
                    path: '/myskov/new-user',
                    query: {
                        navigateBack: true
                    }
                })
            },
            logIn() {
                this.$router.push({
                    path: '/myskov/login',
                    query: {
                        navigateBack: true
                    }
                })
            },
            readMore() {
                if(!this.hotel.id)
                    return;

                if(!this.isFavoriteItem) {
                    let query = this.query;
                    query = _.pick(query, [
                        'fromDate', 
                        'toDate', 
                        'flexibleStartDays', 
                        'flexibleEndDays',
                        'departureAirport', 
                        'adults', 
                        'children', 
                        'minPrice', 
                        'maxPrice', 
                        'roomTypeCode', 
                        'boardTypeCode',
                        'roomLocatedCode', 
                        'directFlight', 
                        'destinationId', 
                        'childrenCount', 
                        'tourOperator',
                        'keywords',
                        'minHotelCategory'
                    ])
                    
                    query = Object.assign({}, query, {
                        fromDate: Moment(query.fromDate).format('YYYY-MM-DD'),
                        toDate: Moment(query.toDate).format('YYYY-MM-DD'),
                        children: (query.children) ? JSON.stringify(query.children) : null,
                        tourOperator: (query.tourOperator) ? JSON.stringify(query.tourOperator) : null,
                        keywords: (query.keywords) ? JSON.stringify(query.keywords) : null
                    });

                    this.$router.push({
                        path: '/offers/' + this.hotel.id,
                        query
                    });
                } else {
                    this.$router.push({
                        path: '/hotels',
                        query: {
                            destinationId: this.hotel.id
                        }
                    });
                }
            }
        },
        components: {
            'hotel-block-header':HotelBlockHeader,
            'total-price':TotalPrice,
            Modal,
            MsgBlock
        }
    }
</script>
